import { useState, useEffect } from 'react'
import { getSubmittalMeta } from '@/services/submittalService'
import { generateOtp } from '@/services/otpService'

const FALLBACK_COOLDOWN_S = 60

export const useAutoLogin = (
  submittalId,
  { consultantId, onSuccess, onBlocked, onError, onNotFound }
) => {
  const [loading, setLoading] = useState(!!submittalId && !!consultantId)

  useEffect(() => {
    if (!submittalId || !consultantId) return

    let cancelled = false

    const run = async () => {
      setLoading(true)

      let email = ''
      try {
        const details = await getSubmittalMeta(submittalId, consultantId)
        email = details?.consultant?.email ?? ''
      } catch (err) {
        if (!cancelled) {
          setLoading(false)
          if (err?.response?.status === 404) {
            onNotFound?.(err.response.data?.detail)
          } else {
            onError?.(err?.response?.data?.detail || 'Failed to load submittal. Please try again.')
          }
        }
        return
      }

      if (!email) {
        if (!cancelled) setLoading(false)
        return
      }

      try {
        await generateOtp(email)
        if (!cancelled) onSuccess({ email, cooldown: FALLBACK_COOLDOWN_S })
      } catch (err) {
        if (cancelled) return
        if (err?.response?.status === 425) {
          onSuccess({ email, cooldown: err.response.data?.retry_after ?? FALLBACK_COOLDOWN_S })
        } else if (err?.response?.status === 429) {
          onBlocked({ email })
        } else {
          onError(err?.response?.data?.detail || 'Failed to send OTP. Please try again.')
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    run()
    return () => {
      cancelled = true
    }
  }, [submittalId, consultantId])
  // callbacks (onSuccess, onError, onNotFound) are stable refs from the parent (state setters + navigate)

  return { loading }
}
